exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*\n    Colors named using http://chir.ag/projects/name-that-color/\n*/\n/******************************\n    Monochrome, Greys\n*******************************/\n/* could be f9f9f9 */\n/******************************\n    Standard Colors\n*******************************/\n.baltic-sea {\n  background-color: #2d2c30; }\n\n.highlight-text {\n  color: #ad974f;\n  font-weight: 300 !important; }\n\n.image-area {\n  float: right;\n  padding: 40px 10px 10px 20px; }\n\n.email-address {\n  text-decoration: underline; }\n\n.closed {\n  color: #e00000; }\n\n.cfp-text-block ul, .cfp-text-block ol {\n  margin-left: 40px; }\n\n.cfp-text-block .tab-title {\n  margin-bottom: 10px;\n  margin-top: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/pages/CallForPapers/CallForPapers.scss
// module id = 1003
// module chunks = 0